module.exports = __webpack_public_path__ + "77313c9ccbc25eabf1febf3495cd302f.svg";